<template>
  <el-main class='main' style="height: calc(100vh - 56px - 20px)">
    <el-input v-model="name" placeholder="请输入名称" style="width: 200px;"></el-input>
    <el-button type="success" @click="query" icon="el-icon-search" style="float: right;background-color: #209323;">查询</el-button>
    <el-button @click="digAdd" icon="el-icon-plus" style="float: right;margin-right: 10px;">添加</el-button>
    <el-table
      :data='tableData'
      style="width: 100%; margin-top: 10px;">
      <el-table-column
        fixed
        prop= 'id'
        label= '编号'
        width= '80'>
      </el-table-column>
      <el-table-column
        prop= 'descr'
        label= '新增时备注'>
      </el-table-column>
      <el-table-column
        prop= 'optDescr'
        label= '操作时备注'>
      </el-table-column>
      <el-table-column
        prop= 'userInfoId'
        label= '操作用户信息id'>
      </el-table-column>
      <el-table-column
        prop= 'optUser'
        label= '操作信息'>
      </el-table-column>
      <el-table-column
        prop= 'type'
        label= '操作类型'>
      </el-table-column>
      <el-table-column
        prop= 'biotaId'
        label= '生物id'>
      </el-table-column>
      <el-table-column
        prop= 'biotaGrowthStageModelAricultureOptId'
        label= '农事操作模型id'>
      </el-table-column>
      <el-table-column
        prop= 'groundId'
        label= '土地id'>
      </el-table-column>
      <el-table-column
        prop= 'groudBiotaId'
        label= '作物和土地关联id'>
      </el-table-column>
      <el-table-column
        prop= 'optIdealTime'
        label= '理想操作时间'>
      </el-table-column>
      <el-table-column
        prop= 'optRealityTime'
        label= '实际操作时间'>
      </el-table-column>

      <el-table-column
        fixed= 'right'
        label= '操作'
        width= '100'>
        <template slot-scope='scope'>
          <el-button @click='digEdit(scope.row)' type='text' size='small' style="color: #209323">编辑</el-button>
          <el-popover
            :ref="'delRef-'+scope.row.id"
            placement="right"
            width="160"
            trigger="click">
            <p>确定【编号:{{scope.row.id}}】删除吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="delClose(scope.row)">取消</el-button>
              <el-button type="primary" size="mini" style="background-color: #209323;" @click="del(scope.row)">确定</el-button>
            </div>
            <el-button slot="reference" type='text' size='small' style="color: #f56c6c">删除</el-button>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
    <el-row style="text-align: right;margin-top: 20px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="current"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-row>
    <el-dialog title="操作表单" :visible.sync="dialogFormVisible">
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="新增时备注" :label-width="formLabelWidth" prop="descr">
          <el-input v-model="form.descr" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="操作时备注" :label-width="formLabelWidth" prop="optDescr">
          <el-input v-model="form.optDescr" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="操作用户信息id" :label-width="formLabelWidth" prop="userInfoId">
          <el-input type="number" v-model.number="form.userInfoId" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="操作信息" :label-width="formLabelWidth" prop="optUser">
          <el-input v-model="form.optUser" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="操作类型" :label-width="formLabelWidth" prop="type">
          <el-input type="number" v-model.number="form.type" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="生物id" :label-width="formLabelWidth" prop="biotaId">
          <el-input type="number" v-model.number="form.biotaId" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="农事操作模型id" :label-width="formLabelWidth" prop="biotaGrowthStageModelAricultureOptId">
          <el-input type="number" v-model.number="form.biotaGrowthStageModelAricultureOptId" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="土地id" :label-width="formLabelWidth" prop="groundId">
          <el-input type="number" v-model.number="form.groundId" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="作物和土地关联id" :label-width="formLabelWidth" prop="groudBiotaId">
          <el-input type="number" v-model.number="form.groudBiotaId" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="理想操作时间" :label-width="formLabelWidth" prop="optIdealTime">
          <el-input v-model="form.optIdealTime" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="实际操作时间" :label-width="formLabelWidth" prop="optRealityTime">
          <el-input v-model="form.optRealityTime" autocomplete="off"></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" style="background-color: #209323;" >确 定</el-button>
      </div>
    </el-dialog>
  </el-main>
</template>
<script>
import requestService from '../../../util/request'
export default {
  data () {
    return {
      tableData: [],
      name: '',
      dialogFormVisible: false,
      form: {
        id: null,
        addTime: null,
        upTime: null,
        descr: null,
        optDescr: null,
        userInfoId: null,
        optUser: null,
        type: null,
        biotaId: null,
        biotaGrowthStageModelAricultureOptId: null,
        groundId: null,
        groudBiotaId: null,
        optIdealTime: null,
        optRealityTime: null
      },
      rules: {
        userInfoId: [{ type: 'integer', message: '需要整型数据类型', trigger: ['change', 'blur'] }],
        type: [{ type: 'integer', message: '需要整型数据类型', trigger: ['change', 'blur'] }],
        biotaId: [{ type: 'integer', message: '需要整型数据类型', trigger: ['change', 'blur'] }],
        biotaGrowthStageModelAricultureOptId: [{ type: 'integer', message: '需要整型数据类型', trigger: ['change', 'blur'] }],
        groundId: [{ type: 'integer', message: '需要整型数据类型', trigger: ['change', 'blur'] }],
        groudBiotaId: [{ type: 'integer', message: '需要整型数据类型', trigger: ['change', 'blur'] }],
        optIdealTime: [{ type: 'date', message: '日期类型不正确', trigger: ['change', 'blur'] }],
        optRealityTime: [{ type: 'date', message: '日期类型不正确', trigger: ['change', 'blur'] }]
      },
      formLabelWidth: '120px',
      current: 1,
      pageSize: 10,
      total: 0,
      pages: 0
    }
  },
  created () {
    this.query()
  },
  methods: {
    del (row) {
      let that = this
      document.body.click()
      let params = {
        id: row.id
      }
      requestService.post('/aricultureOpt/del', params, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.query()
      })
    },
    delClose (row) {
      document.body.click()
    },
    query () {
      let that = this
      requestService.get(`/aricultureOpt/listPage?current=${that.current}&pageSize=${that.pageSize}`, {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        // console.log(res)
        that.tableData = res.data.body.records
        that.total = res.data.body.total
        that.pages = res.data.body.pages
      })
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.query()
    },
    handleCurrentChange (val) {
      this.current = val
      this.query()
    },
    digEdit (row = {}) {
      this.form = {...row}
      this.dialogFormVisible = true
    },
    digAdd () {
      this.form = {}
      this.dialogFormVisible = true
    },
    submitForm (formName) {
      let that = this
      this.$refs[formName].validate((valid) => {
        console.log(valid)
        if (valid) {
          that.dialogFormVisible = false
          console.log('add')
          let url = '/aricultureOpt/add'
          if (that.form.id) {
            url = '/aricultureOpt/edit'
          }
          requestService.post(url, that.form, {headers: {'Content-Type': 'application/json'}}).then((res) => {
            that.query()
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/org-manage-components/aricultureOpt/Index.vue